"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CHAIN_NAME = exports.DEFAULT_CHAIN_ID = exports.CONCENTRATED_SUBGRAPH_NAME = exports.KASHI_SUBGRAPH_NAME = exports.FURO_SUBGRAPH_NAME = exports.FURO_ENABLED_NETWORKS = exports.MASTERCHEF_V2_SUBGRAPH_NAME = exports.MASTERCHEF_V1_SUBGRAPH_NAME = exports.MINICHEF_SUBGRAPH_NAME = exports.TRIDENT_SUBGRAPH_START_BLOCK = exports.TRIDENT_SUBGRAPH_NAME = exports.SUSHISWAP_V3_SUBGRAPH_NAME = exports.SUSHISWAP_SUBGRAPH_NAME = exports.EXCHANGE_SUBGRAPH_NAME = exports.SECONDS_BETWEEN_BLOCKS = exports.BLOCKS_SUBGRAPH_NAME = exports.BENTOBOX_ENABLED_NETWORKS = exports.BENTOBOX_SUBGRAPH_NAME = exports.SUBGRAPH_HOST = exports.CHAIN_NAME = exports.THUNDERCORE_HOST = exports.POLYGON_ZKEVM_HOST = exports.PENDING_METIS_HOST = exports.METIS_HOST = exports.PENDING_KAVA_HOST = exports.KAVA_HOST = exports.PENDING_GRAPH_HOST = exports.GRAPH_HOST = exports.SWAP_ENABLED_NETWORKS = exports.SUSHISWAP_V3_ENABLED_NETWORKS = exports.SUSHISWAP_ENABLED_NETWORKS = exports.TRIDENT_ENABLED_NETWORKS = void 0;
const chain_1 = require("@sushiswap/chain");
exports.TRIDENT_ENABLED_NETWORKS = [
    chain_1.ChainId.OPTIMISM,
    chain_1.ChainId.POLYGON,
    chain_1.ChainId.KAVA,
    chain_1.ChainId.METIS,
    chain_1.ChainId.BTTC,
    chain_1.ChainId.ARBITRUM,
    chain_1.ChainId.AVALANCHE,
    chain_1.ChainId.BSC,
];
exports.SUSHISWAP_ENABLED_NETWORKS = [
    chain_1.ChainId.ARBITRUM,
    chain_1.ChainId.AVALANCHE,
    chain_1.ChainId.BSC,
    chain_1.ChainId.CELO,
    chain_1.ChainId.ETHEREUM,
    chain_1.ChainId.FANTOM,
    chain_1.ChainId.FUSE,
    chain_1.ChainId.GNOSIS,
    chain_1.ChainId.MOONBEAM,
    chain_1.ChainId.MOONRIVER,
    chain_1.ChainId.POLYGON,
    chain_1.ChainId.HARMONY,
    chain_1.ChainId.ARBITRUM_NOVA,
    chain_1.ChainId.BOBA,
    chain_1.ChainId.BOBA_AVAX,
    chain_1.ChainId.BOBA_BNB,
    // ChainId.PALM,
    // ChainId.HECO,
    // ChainId.OKEX
];
exports.SUSHISWAP_V3_ENABLED_NETWORKS = [
    chain_1.ChainId.ETHEREUM,
    chain_1.ChainId.ARBITRUM_NOVA,
    chain_1.ChainId.ARBITRUM,
    chain_1.ChainId.AVALANCHE,
    chain_1.ChainId.BSC,
    chain_1.ChainId.BOBA,
    chain_1.ChainId.FANTOM,
    chain_1.ChainId.FUSE,
    chain_1.ChainId.GNOSIS,
    chain_1.ChainId.MOONRIVER,
    chain_1.ChainId.OPTIMISM,
    chain_1.ChainId.POLYGON,
    chain_1.ChainId.POLYGON_ZKEVM,
    chain_1.ChainId.THUNDERCORE,
];
exports.SWAP_ENABLED_NETWORKS = Array.from(new Set([...exports.SUSHISWAP_ENABLED_NETWORKS, ...exports.SUSHISWAP_V3_ENABLED_NETWORKS, ...exports.TRIDENT_ENABLED_NETWORKS]));
exports.GRAPH_HOST = 'api.thegraph.com/subgraphs/name';
exports.PENDING_GRAPH_HOST = 'api.thegraph.com/subgraphs/id';
exports.KAVA_HOST = 'pvt.graph.kava.io/subgraphs/name';
exports.PENDING_KAVA_HOST = 'pvt.graph.kava.io/subgraphs/id';
exports.METIS_HOST = 'andromeda.thegraph.metis.io/subgraphs/name';
exports.PENDING_METIS_HOST = 'andromeda.thegraph.metis.io/subgraphs/id';
exports.POLYGON_ZKEVM_HOST = 'api.studio.thegraph.com/query/32073';
exports.THUNDERCORE_HOST = 'graph-node.thundercore.com/subgraphs/name';
exports.CHAIN_NAME = {
    [chain_1.ChainId.ARBITRUM]: 'Arbitrum',
    [chain_1.ChainId.AVALANCHE]: 'Avalanche',
    [chain_1.ChainId.BSC]: 'Bsc',
    [chain_1.ChainId.ETHEREUM]: 'Ethereum',
    [chain_1.ChainId.FANTOM]: 'Fantom',
    [chain_1.ChainId.GNOSIS]: 'Gnosis',
    [chain_1.ChainId.GÖRLI]: 'Görli',
    [chain_1.ChainId.HARMONY]: 'Harmony',
    [chain_1.ChainId.MOONBEAM]: 'Moonbeam',
    [chain_1.ChainId.MOONRIVER]: 'Moonriver',
    [chain_1.ChainId.OPTIMISM]: 'Optimism',
    [chain_1.ChainId.POLYGON]: 'Polygon',
    [chain_1.ChainId.TELOS]: 'Telos',
    [chain_1.ChainId.CELO]: 'Celo',
    [chain_1.ChainId.FUSE]: 'Fuse',
    [chain_1.ChainId.OKEX]: 'OKEx',
    [chain_1.ChainId.HECO]: 'HECO',
    [chain_1.ChainId.PALM]: 'Palm',
    [chain_1.ChainId.KAVA]: 'Kava',
    [chain_1.ChainId.METIS]: 'Metis',
    [chain_1.ChainId.BOBA]: 'Boba',
    [chain_1.ChainId.ARBITRUM_NOVA]: 'Arbitrum Nova',
    [chain_1.ChainId.BOBA_AVAX]: 'Boba Avax',
    [chain_1.ChainId.BOBA_BNB]: 'Boba BNB',
    [chain_1.ChainId.BTTC]: 'BitTorrent',
    [chain_1.ChainId.THUNDERCORE]: 'ThunderCore',
    [chain_1.ChainId.POLYGON_ZKEVM]: 'Polygon zkEVM',
};
exports.SUBGRAPH_HOST = {
    [chain_1.ChainId.ARBITRUM]: exports.GRAPH_HOST,
    [chain_1.ChainId.ARBITRUM_NOVA]: 'subgraphs.sushi.com/subgraphs/name',
    [chain_1.ChainId.AVALANCHE]: exports.GRAPH_HOST,
    [chain_1.ChainId.BSC]: exports.GRAPH_HOST,
    [chain_1.ChainId.CELO]: exports.GRAPH_HOST,
    [chain_1.ChainId.ETHEREUM]: exports.GRAPH_HOST,
    [chain_1.ChainId.FANTOM]: exports.GRAPH_HOST,
    [chain_1.ChainId.FUSE]: exports.GRAPH_HOST,
    [chain_1.ChainId.GNOSIS]: exports.GRAPH_HOST,
    [chain_1.ChainId.GÖRLI]: exports.GRAPH_HOST,
    [chain_1.ChainId.HARMONY]: exports.GRAPH_HOST,
    [chain_1.ChainId.KAVA]: exports.KAVA_HOST,
    [chain_1.ChainId.METIS]: exports.METIS_HOST,
    [chain_1.ChainId.MOONBEAM]: exports.GRAPH_HOST,
    [chain_1.ChainId.MOONRIVER]: exports.GRAPH_HOST,
    [chain_1.ChainId.OPTIMISM]: 'api.thegraph.com/subgraphs/name',
    [chain_1.ChainId.POLYGON]: exports.GRAPH_HOST,
    [chain_1.ChainId.POLYGON_ZKEVM]: exports.POLYGON_ZKEVM_HOST,
    [chain_1.ChainId.BOBA]: exports.GRAPH_HOST,
    [chain_1.ChainId.BOBA_AVAX]: 'subgraphs.sushi.com/subgraphs/name',
    [chain_1.ChainId.BOBA_BNB]: 'subgraphs.sushi.com/subgraphs/name',
    [chain_1.ChainId.BTTC]: 'subgraphs.sushi.com/subgraphs/name',
    [chain_1.ChainId.OKEX]: '',
    [chain_1.ChainId.HECO]: '',
    [chain_1.ChainId.KOVAN]: '',
    [chain_1.ChainId.THUNDERCORE]: exports.THUNDERCORE_HOST,
};
exports.BENTOBOX_SUBGRAPH_NAME = {
    [chain_1.ChainId.ETHEREUM]: 'sushiswap/bentobox-ethereum',
    [chain_1.ChainId.POLYGON]: 'sushiswap/bentobox-polygon',
    [chain_1.ChainId.AVALANCHE]: 'sushiswap/bentobox-avalanche',
    [chain_1.ChainId.BSC]: 'sushiswap/bentobox-bsc',
    [chain_1.ChainId.FANTOM]: 'sushiswap/bentobox-fantom',
    [chain_1.ChainId.GNOSIS]: 'sushiswap/bentobox-gnosis',
    [chain_1.ChainId.ARBITRUM]: 'sushiswap/bentobox-arbitrum',
    [chain_1.ChainId.CELO]: 'sushiswap/bentobox-celo',
    [chain_1.ChainId.MOONRIVER]: 'sushiswap/bentobox-moonriver',
    [chain_1.ChainId.MOONBEAM]: 'sushiswap/bentobox-moonbeam',
    [chain_1.ChainId.OPTIMISM]: 'sushiswap/bentobox-optimism',
    [chain_1.ChainId.HARMONY]: 'sushiswap/bentobox-harmony',
    [chain_1.ChainId.KAVA]: 'sushiswap/bentobox-kava',
    [chain_1.ChainId.BTTC]: 'sushiswap/bentobox-bttc',
};
exports.BENTOBOX_ENABLED_NETWORKS = Object.keys(exports.BENTOBOX_SUBGRAPH_NAME).map(Number);
exports.BLOCKS_SUBGRAPH_NAME = {
    [chain_1.ChainId.ETHEREUM]: 'blocklytics/ethereum-blocks',
    [chain_1.ChainId.GNOSIS]: 'matthewlilley/xdai-blocks',
    [chain_1.ChainId.POLYGON]: 'matthewlilley/polygon-blocks',
    [chain_1.ChainId.POLYGON_ZKEVM]: 'blocks-polygon-zkevm/v0.0.2',
    [chain_1.ChainId.FANTOM]: 'matthewlilley/fantom-blocks',
    [chain_1.ChainId.BSC]: 'matthewlilley/bsc-blocks',
    [chain_1.ChainId.HARMONY]: 'sushiswap/harmony-blocks',
    [chain_1.ChainId.AVALANCHE]: 'matthewlilley/avalanche-blocks',
    [chain_1.ChainId.CELO]: 'ubeswap/celo-blocks',
    [chain_1.ChainId.ARBITRUM]: 'sushiswap/arbitrum-blocks',
    [chain_1.ChainId.OKEX]: 'okexchain-blocks/oec',
    [chain_1.ChainId.HECO]: 'hecoblocks/heco',
    [chain_1.ChainId.MOONRIVER]: 'sushiswap/moonriver-blocks',
    [chain_1.ChainId.FUSE]: 'sushiswap/fuse-blocks',
    [chain_1.ChainId.KOVAN]: 'blocklytics/kovan-blocks',
    [chain_1.ChainId.MOONBEAM]: 'sushiswap/moonbeam-blocks',
    [chain_1.ChainId.OPTIMISM]: 'beethovenxfi/optimism-blocks',
    [chain_1.ChainId.KAVA]: 'sushiswap/blocks-kava',
    [chain_1.ChainId.METIS]: 'sushiswap/blocks-metis',
    [chain_1.ChainId.ARBITRUM_NOVA]: 'sushiswap/blocks-arbitrum-nova',
    [chain_1.ChainId.BOBA]: 'sushiswap/blocks-boba',
    [chain_1.ChainId.BOBA_AVAX]: 'sushiswap/blocks-boba-avax',
    [chain_1.ChainId.BOBA_BNB]: 'sushiswap/blocks-boba-bnb',
    [chain_1.ChainId.BTTC]: 'sushiswap/blocks-bttc',
    [chain_1.ChainId.THUNDERCORE]: 'sushiswap/blocks-thundercore',
};
exports.SECONDS_BETWEEN_BLOCKS = {
    [chain_1.ChainId.ETHEREUM]: 12,
    [chain_1.ChainId.GNOSIS]: 5,
    [chain_1.ChainId.POLYGON]: 2,
    [chain_1.ChainId.POLYGON_ZKEVM]: 5,
    [chain_1.ChainId.FANTOM]: 2,
    [chain_1.ChainId.BSC]: 3,
    [chain_1.ChainId.HARMONY]: 2,
    [chain_1.ChainId.AVALANCHE]: 2,
    [chain_1.ChainId.CELO]: 5,
    [chain_1.ChainId.ARBITRUM]: 0.25,
    [chain_1.ChainId.OKEX]: 3.8,
    [chain_1.ChainId.HECO]: 3,
    [chain_1.ChainId.MOONRIVER]: 12.2,
    [chain_1.ChainId.FUSE]: 5,
    [chain_1.ChainId.KOVAN]: 4,
    [chain_1.ChainId.MOONBEAM]: 12.2,
    [chain_1.ChainId.OPTIMISM]: 2,
    [chain_1.ChainId.KAVA]: 6.3,
    [chain_1.ChainId.METIS]: 4.5,
    [chain_1.ChainId.ARBITRUM_NOVA]: 1,
    [chain_1.ChainId.BOBA]: 250,
    [chain_1.ChainId.BOBA_AVAX]: 612,
    [chain_1.ChainId.BOBA_BNB]: 0.5,
    [chain_1.ChainId.BTTC]: 2,
    [chain_1.ChainId.THUNDERCORE]: 1,
};
exports.EXCHANGE_SUBGRAPH_NAME = {
    [chain_1.ChainId.AVALANCHE]: 'sushiswap/exchange-avalanche',
    [chain_1.ChainId.ARBITRUM]: 'sushiswap/exchange-arbitrum-backup',
    [chain_1.ChainId.BSC]: 'sushiswap/bsc-exchange',
    [chain_1.ChainId.CELO]: 'sushiswap/exchange-celo',
    [chain_1.ChainId.ETHEREUM]: 'sushiswap/exchange-ethereum',
    [chain_1.ChainId.FANTOM]: 'sushiswap/exchange-fantom',
    [chain_1.ChainId.FUSE]: 'sushiswap/exchange-fuse',
    [chain_1.ChainId.GNOSIS]: 'sushiswap/xdai-exchange',
    [chain_1.ChainId.MOONBEAM]: 'sushiswap/exchange-moonbeam',
    [chain_1.ChainId.MOONRIVER]: 'sushiswap/exchange-moonriver',
    [chain_1.ChainId.POLYGON]: 'sushiswap/matic-exchange',
    [chain_1.ChainId.HARMONY]: 'sushiswap/exchange-harmony',
    [chain_1.ChainId.ARBITRUM_NOVA]: 'sushi-0m/sushiswap-arbitrum-nova',
    [chain_1.ChainId.POLYGON]: 'sushiswap/exchange-polygon',
    [chain_1.ChainId.BOBA]: 'sushi-0m/sushiswap-boba',
    [chain_1.ChainId.BOBA_AVAX]: 'sushi-0m/sushiswap-boba-avax',
    [chain_1.ChainId.BOBA_BNB]: 'sushi-0m/sushiswap-boba-bnb',
};
exports.SUSHISWAP_SUBGRAPH_NAME = {
    [chain_1.ChainId.ETHEREUM]: 'sushi-v2/sushiswap-ethereum',
    [chain_1.ChainId.AVALANCHE]: 'sushi-v2/sushiswap-avalanche',
    [chain_1.ChainId.ARBITRUM]: 'sushi-v2/sushiswap-arbitrum',
    [chain_1.ChainId.BSC]: 'sushi-v2/sushiswap-bsc',
    [chain_1.ChainId.CELO]: 'sushi-v2/sushiswap-celo',
    [chain_1.ChainId.FANTOM]: 'sushi-v2/sushiswap-fantom',
    [chain_1.ChainId.FUSE]: 'sushi-v2/sushiswap-fuse',
    [chain_1.ChainId.GNOSIS]: 'sushi-v2/sushiswap-gnosis',
    [chain_1.ChainId.MOONBEAM]: 'sushi-v2/sushiswap-moonbeam',
    [chain_1.ChainId.MOONRIVER]: 'sushi-v2/sushiswap-moonriver',
    [chain_1.ChainId.HARMONY]: 'olastenberg/sushiswap-harmony-fix',
    [chain_1.ChainId.ARBITRUM_NOVA]: 'sushi-0m/sushiswap-arbitrum-nova',
    [chain_1.ChainId.BOBA]: 'sushi-v2/sushiswap-boba',
    [chain_1.ChainId.POLYGON]: 'sushi-v2/sushiswap-polygon',
    [chain_1.ChainId.BOBA_AVAX]: 'sushi-0m/sushiswap-boba-avax',
    [chain_1.ChainId.BOBA_BNB]: 'sushi-0m/sushiswap-boba-bnb',
};
exports.SUSHISWAP_V3_SUBGRAPH_NAME = {
    [chain_1.ChainId.ARBITRUM_NOVA]: 'sushi-v3/v3-arbitrum-nova',
    [chain_1.ChainId.ARBITRUM]: 'sushi-v3/v3-arbitrum',
    [chain_1.ChainId.AVALANCHE]: 'sushi-v3/v3-avalanche',
    [chain_1.ChainId.BSC]: 'sushi-v3/v3-bsc',
    [chain_1.ChainId.BOBA]: 'sushi-v3/v3-boba',
    [chain_1.ChainId.ETHEREUM]: 'sushi-v3/v3-ethereum',
    [chain_1.ChainId.FANTOM]: 'sushi-v3/v3-fantom',
    [chain_1.ChainId.FUSE]: 'sushi-v3/v3-fuse',
    [chain_1.ChainId.GNOSIS]: 'sushi-v3/v3-gnosis',
    [chain_1.ChainId.MOONRIVER]: 'sushi-v3/v3-moonriver',
    [chain_1.ChainId.OPTIMISM]: 'sushi-v3/v3-optimism',
    [chain_1.ChainId.POLYGON]: 'sushi-v3/v3-polygon',
    [chain_1.ChainId.POLYGON_ZKEVM]: 'v3-polygon-zkevm/v0.0.2',
    [chain_1.ChainId.THUNDERCORE]: 'sushi-v3/v3-thundercore',
};
exports.TRIDENT_SUBGRAPH_NAME = {
    [chain_1.ChainId.POLYGON]: 'sushi-v2/trident-polygon',
    [chain_1.ChainId.OPTIMISM]: 'sushi-v2/trident-optimism',
    [chain_1.ChainId.KAVA]: 'sushi-qa/trident-kava',
    [chain_1.ChainId.METIS]: 'sushi-v2/trident-metis',
    [chain_1.ChainId.BTTC]: 'sushi-v2/trident-bttc',
    [chain_1.ChainId.ARBITRUM]: 'sushi-v2/trident-arbitrum',
    [chain_1.ChainId.BSC]: 'sushi-v2/trident-bsc',
    [chain_1.ChainId.AVALANCHE]: 'sushi-v2/trident-avalanche',
};
exports.TRIDENT_SUBGRAPH_START_BLOCK = {
    [chain_1.ChainId.POLYGON]: 34188953,
    [chain_1.ChainId.OPTIMISM]: 7464195,
    [chain_1.ChainId.KAVA]: 162097,
    [chain_1.ChainId.METIS]: 3030678,
    [chain_1.ChainId.BTTC]: 13304596,
    [chain_1.ChainId.ARBITRUM]: 43756724,
    [chain_1.ChainId.BSC]: 23136876,
    [chain_1.ChainId.AVALANCHE]: 22495996,
};
exports.MINICHEF_SUBGRAPH_NAME = {
    [chain_1.ChainId.POLYGON]: 'jiro-ono/minichef-staging-updates',
    [chain_1.ChainId.GNOSIS]: 'jiro-ono/gnosis-minichef-staging',
    // [ChainId.HARMONY]: 'sushiswap/harmony-minichef', // subgraph broken
    [chain_1.ChainId.ARBITRUM]: 'jiro-ono/arbitrum-minichef-staging',
    [chain_1.ChainId.CELO]: 'sushiswap/celo-minichef-v2',
    [chain_1.ChainId.MOONRIVER]: 'sushiswap/moonriver-minichef',
    [chain_1.ChainId.FUSE]: 'sushiswap/fuse-minichef',
    [chain_1.ChainId.FANTOM]: 'sushiswap/fantom-minichef',
    [chain_1.ChainId.MOONBEAM]: 'sushiswap/moonbeam-minichef',
    [chain_1.ChainId.KAVA]: 'sushiswap/kava-minichef',
    [chain_1.ChainId.METIS]: 'sushiswap/metis-minichef',
    [chain_1.ChainId.BOBA]: 'sushiswap/minichef-boba',
    [chain_1.ChainId.ARBITRUM_NOVA]: 'sushiswap/minichef-arbitrum-nova',
    [chain_1.ChainId.BTTC]: 'sushiswap/minichef-bttc',
    [chain_1.ChainId.OPTIMISM]: 'sushiswap/minichef-optimism',
    [chain_1.ChainId.AVALANCHE]: 'sushiswap/minichef-avalanche',
    [chain_1.ChainId.BSC]: 'sushiswap/minichef-bsc',
};
exports.MASTERCHEF_V1_SUBGRAPH_NAME = 'jiro-ono/masterchef-staging';
exports.MASTERCHEF_V2_SUBGRAPH_NAME = 'sushiswap/master-chefv2';
exports.FURO_ENABLED_NETWORKS = [
    chain_1.ChainId.ETHEREUM,
    chain_1.ChainId.ARBITRUM,
    chain_1.ChainId.AVALANCHE,
    chain_1.ChainId.BSC,
    chain_1.ChainId.FANTOM,
    chain_1.ChainId.GNOSIS,
    chain_1.ChainId.HARMONY,
    chain_1.ChainId.MOONBEAM,
    chain_1.ChainId.MOONRIVER,
    chain_1.ChainId.OPTIMISM,
    chain_1.ChainId.POLYGON,
];
// TODO: Make typesafe
exports.FURO_SUBGRAPH_NAME = {
    [chain_1.ChainId.ETHEREUM]: 'sushi-subgraphs/furo-ethereum',
    [chain_1.ChainId.GÖRLI]: 'sushi-subgraphs/furo-goerli',
    [chain_1.ChainId.ARBITRUM]: 'sushi-subgraphs/furo-arbitrum',
    [chain_1.ChainId.AVALANCHE]: 'sushi-subgraphs/furo-avalanche',
    [chain_1.ChainId.BSC]: 'sushi-subgraphs/furo-bsc',
    [chain_1.ChainId.FANTOM]: 'sushi-subgraphs/furo-fantom',
    [chain_1.ChainId.GNOSIS]: 'sushi-subgraphs/furo-gnosis',
    [chain_1.ChainId.HARMONY]: 'sushi-subgraphs/furo-harmony',
    [chain_1.ChainId.MOONBEAM]: 'sushi-subgraphs/furo-moonbeam',
    [chain_1.ChainId.MOONRIVER]: 'sushi-subgraphs/furo-moonriver',
    [chain_1.ChainId.OPTIMISM]: 'sushi-subgraphs/furo-optimism',
    [chain_1.ChainId.POLYGON]: 'sushi-subgraphs/furo-polygon',
};
exports.KASHI_SUBGRAPH_NAME = {
    [chain_1.ChainId.ARBITRUM]: 'sushiswap/kashi-arbitrum',
};
exports.CONCENTRATED_SUBGRAPH_NAME = {
    [chain_1.ChainId.ETHEREUM]: 'uniswap/uniswap-v3',
    [chain_1.ChainId.ARBITRUM]: 'ianlapham/arbitrum-minimal',
};
exports.DEFAULT_CHAIN_ID = chain_1.ChainId.ETHEREUM;
exports.DEFAULT_CHAIN_NAME = exports.CHAIN_NAME[exports.DEFAULT_CHAIN_ID];
//# sourceMappingURL=index.js.map